import axiosInstance from './axios';

/**
 * Insights API - News, Sentiment, AI Analysis
 */

// Get comprehensive portfolio insights (news + sentiment + AI)
export const getPortfolioInsights = async (days = 7) => {
  try {
    const response = await axiosInstance.get(`/api/portfolio/insights/`, {
      params: { days }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching portfolio insights:', error);
    throw error;
  }
};

// Get news and analysis for specific stock
export const getStockNews = async (symbol, days = 7) => {
  try {
    const response = await axiosInstance.get(`/api/news/${symbol}/`, {
      params: { days }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching news for ${symbol}:`, error);
    throw error;
  }
};

// Check article for fake news
export const checkFakeNews = async (articleData) => {
  try {
    const response = await axiosInstance.post('/api/news/fake-news-check/', articleData);
    return response.data;
  } catch (error) {
    console.error('Error checking fake news:', error);
    throw error;
  }
};

// -------- The Watch (Phase 3): daily brief / alerts --------

// Latest daily brief for the Home Today card. Returns null on 204.
export const getTodayInsight = async () => {
  try {
    const response = await axiosInstance.get('/api/insights/today/');
    if (response.status === 204) return null;
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) throw error;
    console.error('Error fetching today\'s brief:', error);
    return null;
  }
};

export const listInsights = async (kind) => {
  const response = await axiosInstance.get('/api/insights/', {
    params: kind ? { kind } : undefined,
  });
  return response.data;
};

export const markInsightRead = async (id) => {
  const response = await axiosInstance.post(`/api/insights/${id}/read/`);
  return response.data;
};
